import InteractiveAccordionTable from 'main/components/tables/interactive/components/accordion_table/InteractiveAccordionTable';

export default InteractiveAccordionTable;
